import { ActionCreatorWithOptionalPayload, ActionCreatorWithPayload, createAction, Dispatch } from '@reduxjs/toolkit';
import * as Actions from './types';
import {
  InvoicingDetailsInterface,
  ProfileDataInterface,
  SettingIntegrationInterface,
  SubscriptionDataInterface,
  UpdateThemeInterface
} from '../interfaces/SettingsInterface';
import { PropsNameWithValueInterface } from '../interfaces/ReducerInterface';

/**
 * @desc Set Project loader
 */
export const setSettingLoader: ActionCreatorWithPayload<boolean, string> = createAction(Actions.SET_SETTING_LOADER);

/**
 * @desc Update Theme Mode
 */
export const updateThemeMode: ActionCreatorWithPayload<UpdateThemeInterface, string> = createAction(
  Actions.UPDATE_THEME_MODE
);

/**
 * @desc update user  data
 */
export const setSettingIntegrationData: ActionCreatorWithPayload<SettingIntegrationInterface, string> = createAction(
  Actions.SET_SETTING_INTEGRATION
);

/**
 * @desc Set Subscription List
 */
export const setSubscriptionList: ActionCreatorWithPayload<SubscriptionDataInterface, string> = createAction(
  Actions.SET_SUBSCRIPTION_LIST
);

/**
 * @desc Set Invoicing detail
 */
export const setInvoiceSeting: ActionCreatorWithPayload<InvoicingDetailsInterface, string> = createAction(
  Actions.SET_INVOICE_SETTING
);

/**
 * @desc set Notifications settings details
 */
export const setNotificationsSettingsDetails: ActionCreatorWithPayload<ProfileDataInterface, string> = createAction(
  Actions.SET_NOTIFICATIONS_SETTING_DETAIL
);

/**
 * @desc update Notifications settings details
 */
export const updateNotificationsSettingsDetails: ActionCreatorWithPayload<PropsNameWithValueInterface, string> =
  createAction(Actions.UPDATE_NOTIFICATIONS_SETTING_DETAIL);

/**
 * @desc clear Notifications settings details
 */
export const clearNotificationsSettingsDetails: ActionCreatorWithOptionalPayload<undefined, string> = createAction(
  Actions.CLEAR_NOTIFICATIONS_SETTING_DETAIL
);

/**
 * @desc Set Theme Type
 */
export const setThemeType: ActionCreatorWithPayload<number, string> = createAction(Actions.SET_THEME_TYPE);

/**
 * @desc Clear Setting Data
 */
export const clearSettingData = () => (dispatch: Dispatch) => {
  dispatch(setSettingLoader(false));
  dispatch(setSubscriptionList({ activeSubscription: [], pastSubscription: [] }));
  dispatch(clearNotificationsSettingsDetails());
  // dispatch(setThemeType(COLOR_THEME.LIGHT));
};
